export default __webpack_public_path__ + "static/media/00.84f5d1be.jpg";